import { jsx as e } from "react/jsx-runtime";
function i(r) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 20 2", width: "1em", ...r, children: /* @__PURE__ */ e("path", { d: "M20 1a1 1 0 01-1 1H1a1 1 0 010-2h18a1 1 0 011 1z", fill: "currentColor", fillRule: "evenodd" }) });
}
export {
  i as default
};
